<template>
  <v-card class="my-3" width="270" hover :to="{ name: 'ProductDetail', params: { id: id } }">
    <ToggleWishListItemIcon v-if="user.role === 'child'" :productId="id" />

    <v-img v-if="image" class="my-2" :src="image" :alt="name" height="160" contain>
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-img :src="require('@/assets/img-placeholder.png')" />
        </v-row>
      </template>
    </v-img>
    <v-img v-else class="my-2" :src="require('@/assets/img-placeholder.png')" :alt="name" height="160" contain />

    <v-card-title class="body-heading-small py-2 product-preview-title">{{ name }}</v-card-title>
    <v-card-text class="secondary--text font-weight-bold pb-2">{{ points }} points</v-card-text>
  </v-card>
</template>

<script>
  import ToggleWishListItemIcon from "@/components/WishList/ToggleWishListItemIcon";

  export default {
    name: "Preview",

    props: {
      id: {
        required: true,
      },
      name: {
        required: false,
      },
      image: {
        required: false,
      },
      points: {
        required: false,
      },
    },

    components: { ToggleWishListItemIcon },

    computed: {
      user() {
        return this.$store.getters.userInfo;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .product-preview-title {
    min-height: 75px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Products/Preview.vue